import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { cn } from "@/lib/utils";

interface UserAvatarProps {
  avatarUrl?: string | null;
  fullName?: string | null;
  size?: "sm" | "md" | "lg" | "xl" | "hero";
  className?: string;
}

const sizeClasses = {
  sm: "h-7 w-7 text-[10px]",
  md: "h-10 w-10 text-sm",
  lg: "h-16 w-16 text-xl",
  xl: "h-20 w-20 text-2xl",
  hero: "h-60 w-60 lg:h-[280px] lg:w-[280px] text-6xl",
};

function getInitials(name?: string | null): string {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  return (
    (parts[0]?.[0] || "").toUpperCase() +
    (parts[1]?.[0] || "").toUpperCase()
  );
}

export default function UserAvatar({ avatarUrl, fullName, size = "md", className }: UserAvatarProps) {
  return (
    <Avatar className={cn(sizeClasses[size], className)}>
      {avatarUrl && <AvatarImage src={avatarUrl} alt={fullName || "Avatar"} />}
      <AvatarFallback className={cn("font-medium", (size === "xl" || size === "hero") && "bg-gradient-to-br from-primary to-accent text-primary-foreground")}>
        {getInitials(fullName)}
      </AvatarFallback>
    </Avatar>
  );
}
